/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import PartnerLGCNSImg from './SectionPartners_lg_cns.png';
import PartnerLGScienceImg from './SectionPartners_lg_science_park.png';
import PartnerYoungwooDigiImg from './SectionPartners_youngwoo_digital.png';
import PartnerSamsungSDSImg from './SectionPartners_samsung_sds.png';
import PartnerServeOneImg from './SectionPartners_serve_one.png';
import PartnerSMEnterImg from './SectionPartners_sm_entertainment.png';
import PartnerFireEyeImg from './SectionPartners_fire_eye.jpeg';

const Section = styled.section`
  border: 0px solid #dadce0;
  
  color: #363a3c;
  
  margin-bottom: 100px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HeaderText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 38px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const IMG90 = styled.img`
  height: 90px;
`;
const IMG60 = styled.img`
  height: 60px;
`;
const IMG64 = styled.img`
  height: 64px;
`;
const IMG70 = styled.img`
  height: 70px;
`;
const IMG48 = styled.img`
  height: 48px;
`;
const IMG36 = styled.img`
  height: 36px;
`;

class SectionPartners extends Component {
  render() {
    return (
      <div className="SectionPartners">

        <Section>
          <ContainerFluid className="container-fluid">
            <HeaderText className="header-text">
              <span className="header-text-700">주요 고객사</span>
            </HeaderText>
            <DivFlexboxWrap className="DivFlexboxWrap">
              <DivFlexItem><IMG64 src={PartnerLGCNSImg}/></DivFlexItem>
              <DivFlexItem><IMG90 src={PartnerLGScienceImg}/></DivFlexItem>
              <DivFlexItem><IMG70 src={PartnerYoungwooDigiImg}/></DivFlexItem>
              <DivFlexItem><IMG36 src={PartnerSamsungSDSImg}/></DivFlexItem>
              <DivFlexItem><IMG48 src={PartnerServeOneImg}/></DivFlexItem>
              <DivFlexItem><IMG60 src={PartnerFireEyeImg}/></DivFlexItem>
              <DivFlexItem><IMG90 src={PartnerSMEnterImg}/></DivFlexItem>
            </DivFlexboxWrap>
          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default SectionPartners;
